import { useState, useEffect, useRef, Fragment } from "react";
import axios from "axios";
import { url_234 } from "../../../custom_utilities/api_services";
import images from "../../../utilities/images/images";
import "./WhyMotion.scss";

const AUTO_SCROLL_MS = 3500;

const WhyMotion = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [studentsFeedback, setStudentsFeedback] = useState([]);
  const indexRef = useRef(0);

  const getStudentsFeedback = async () => {
    try {
      const response = await axios.get(url_234);

      if (response.data.status === 200) {
        setStudentsFeedback([...response.data.data.testimonials]);
      }
    } catch (error) {
      console.error("Failed to load testimonials", error);
    }
  };

  useEffect(() => {
    getStudentsFeedback();
  }, []);

  useEffect(() => {
    indexRef.current = currentIndex;
  }, [currentIndex]);

  useEffect(() => {
    if (studentsFeedback.length <= 1) return undefined;

    const timer = setInterval(() => {
      const nextIndex = (indexRef.current + 1) % studentsFeedback.length;
      indexRef.current = nextIndex;
      setCurrentIndex(nextIndex);
    }, AUTO_SCROLL_MS);

    return () => clearInterval(timer);
  }, [studentsFeedback.length]);

  const goToSlide = (index) => {
    indexRef.current = index;
    setCurrentIndex(index);
  };

  const renderTestimonialCard = (feedback) => (
    <div className="student-feedback-container">
      <div className="student-feedback-left">
        <div className="student-image-wrap">
          <img
            src={feedback.student_image}
            alt={feedback.student_name}
            className="studentImage"
          />
        </div>
        <div className="studentDetails">
          <div className="studentName">
            {feedback.student_name}
            {feedback.AIR ? ` (AIR ${feedback.AIR})` : ""}
          </div>
          <div className="studentCourse">{feedback.target}</div>
        </div>
      </div>

      <div className="student-feedback-right">
        <div className="studentReviewIcon">“</div>
        <div className="studentReview">{feedback.testimonials}</div>
      </div>
    </div>
  );

  const activeFeedback = studentsFeedback[currentIndex];

  return (
    <Fragment>
      <div className="why-motion-inner-wrapper">
        <div className="why-motion-left">
          <div className="section-heading">Selection Ratio</div>
          <div className="why-motion-banner">
            <img src={images.whyMotionBanner} alt="why-motion-banner" />
          </div>
        </div>

        <div className="slider-wrapper">
          <div className="section-heading">What Our Student Says</div>

          <div className="slider">
            {activeFeedback ? renderTestimonialCard(activeFeedback) : null}

            {studentsFeedback.length > 1 ? (
              <div className="slider-dots">
                {studentsFeedback.map((_, index) => (
                  <button
                    key={`dot-${index}`}
                    type="button"
                    aria-label={`Go to testimonial ${index + 1}`}
                    className={`slider-dot ${
                      currentIndex === index ? "active" : ""
                    }`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="mobile-why-motion-inner-wrapper">
        <div className="why-motion-left">
          <div className="section-heading">Selection Ratio</div>
          <div className="why-motion-banner">
            <img src={images.whyMotionBanner} alt="why-motion-banner" />
          </div>
        </div>

        <div className="slider-wrapper">
          <div className="section-heading">What Our Student Says</div>

          <div className="slider">
            {activeFeedback ? renderTestimonialCard(activeFeedback) : null}

            {studentsFeedback.length > 1 ? (
              <div className="slider-dots">
                {studentsFeedback.map((_, index) => (
                  <button
                    key={`mobile-dot-${index}`}
                    type="button"
                    aria-label={`Go to testimonial ${index + 1}`}
                    className={`slider-dot ${
                      currentIndex === index ? "active" : ""
                    }`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default WhyMotion;
